import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ManageInvoiceDetail from "../components/ManageInvoiceDetail";

const ManageInvoiceDetailPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Manage Invoice Detail' />

        <ManageInvoiceDetail />

      </MasterLayout>
    </>
  );
};

export default ManageInvoiceDetailPage;
